import { useState } from "react";

const Pagination = ({ currentPage, recordsPerPage, totalRecords, onClick }) => {

    const totalPages = Math.ceil(totalRecords / recordsPerPage);

    return (
        totalPages > 1 && (
            <div className="main-list__pagination">
                {[...Array(totalPages)].map((_, index) => (
                    <button
                        key={index}
                        className={`main-list__page-btn ${currentPage === index + 1  ? "main-list__page-btn--active" : ""}`}
                        onClick={() => onClick(index + 1, index * recordsPerPage, (index * recordsPerPage) + recordsPerPage)}
                    >
                        {index + 1 }
                    </button>
                ))}
            </div>
        )
    );
};

export default Pagination;
